var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 184,
    viewBox: "0 0 401 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4446_2621)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4446_2621)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 393,
    height: 176,
    rx: 20,
    fill: "url(#paint0_linear_4446_2621)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4446_2621)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.089,
    cy: 78.0894,
    rx: 117.012,
    ry: 105.421,
    transform: "rotate(-16.7881 306.089 78.0894)",
    fill: "#A8ADB9",
    fillOpacity: 0.41
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4446_2621)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.003,
    cy: 76.2843,
    rx: 111.763,
    ry: 99.734,
    transform: "rotate(-16.7881 306.003 76.2843)",
    fill: "#0096D1"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.997 58C281.057 58 273 63.324 273 77.6282C273 91.9323 305.288 118 305.288 118C305.288 118 337.576 91.9323 337.576 77.6282C337.576 63.324 329.519 58 319.58 58C313.756 58 308.577 61.0175 305.288 65.6972C301.999 61.0175 296.821 58 290.997 58Z",
    fill: "#E43535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.562 93.6541H291.669L294.774 82.4986L298.428 99.372L302.619 70.1289L306.975 106.691L311.804 76.2058L314.654 94.2109H338.001",
    stroke: "white",
    strokeWidth: 4.18428,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.5,
    cy: 120,
    rx: 32.5,
    ry: 4,
    fill: "url(#paint1_radial_4446_2621)",
    fillOpacity: 0.7
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4446_2621",
    x: 0,
    y: 0,
    width: 401,
    height: 184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4446_2621"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4446_2621",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4446_2621",
    x: 189.97,
    y: -32.126,
    width: 232.237,
    height: 216.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.75104
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.6888
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4446_2621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4446_2621",
    x: 193.29,
    y: -24.5352,
    width: 225.426,
    height: 205.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.87552
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.937759
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0.67 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4446_2621"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4446_2621",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4446_2621",
    x1: 11,
    y1: 0.00000817195,
    x2: 236,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4446_2621",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(306.5 120) rotate(90) scale(4 32.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4446_2621"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 393,
    height: 176,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthBg);
export default __webpack_public_path__ + "static/media/health-bg.7fb2ae6108f7ee5749a309eaa8779f09.svg";
export { ForwardRef as ReactComponent };